import React from 'react';
import { Helmet } from 'react-helmet';
import useToggle from '../../../Hooks/useToggle';
import posBanner from '../../../assets/images/pos-banner.webp';
import posImg2 from '../../../assets/images/pos-bill-list.jpg';
import posImg4 from '../../../assets/images/pos-billing.jpg';
import posImg1 from '../../../assets/images/pos-dashboard-2.jpg';
import posImg5 from '../../../assets/images/pos-kot.jpg';
import posImg3 from '../../../assets/images/pos-report.jpg';
import BackToTop from '../../BackToTop';
import FooterHomeThree from '../../Footer/FooterHomeThree';
import HeaderNews from '../../Header/HeaderNews';
import HeroNews from '../../Header/HeroNews';
import Drawer from '../../Mobile/Drawer';
import PreviewSlider from '../../PreviewSlider';
import ServicesAbout from './ServicesAbout';
import ShowCase from './ShowCase';

function POS() {
    const [drawer, drawerAction] = useToggle(false);
    return (
        <>
            <Helmet>
                <meta
                    name="description"
                    content="Elevate your business with OTO's cutting-edge Point of Sale (POS) solutions in Kigali, Rwanda. Our software suite offers modern, efficient, and user-friendly POS features to streamline your sales process, manage inventory, and boost customer satisfaction. Contact us for a demo!"
                />
                <title>Modern Point of Sale (POS) Solutions by OTO | Kigali, Rwanda</title>
            </Helmet>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderNews action={drawerAction.toggle} />
            <HeroNews
                title="POS : Point Of Sales"
                breadcrumb={[
                    { link: '/', title: 'Home' },
                    { link: '/apps', title: 'Apps' },
                    { link: '/apps/pos', title: 'POS' },
                ]}
            />

            <div className="container pt-90 pb-90" style={{ fontSize: '18px', lineHeight: '29px' }}>
                <h3 className="mb-4">Point Of Sales Software</h3>
                <p className="mb-3">
                    Point of Sale (POS) apps are becoming increasingly popular among businesses of
                    all sizes. A POS app is a software application that runs on a mobile device,
                    tablet or computer, and it allows merchants to process transactions, manage
                    inventory, and analyze sales data in real-time.
                </p>
                <p>
                    Our POS app is perfect for businesses in the hospitality industry, including
                    hotels, restaurants, and bars. With our app, you can streamline your operations,
                    improve efficiency, and gain valuable insights into your business.
                </p>

                <img className="page-banner-img mt-4" src={posBanner} alt="OTO POS Software" />
            </div>
            <ServicesAbout />

            <ShowCase />
            <div className="container">
                <PreviewSlider
                    images={[
                        { url: posImg1, alt: 'POS Dashboard' },
                        { url: posImg2, alt: 'POS Bill List' },
                        { url: posImg3, alt: 'POS Report' },
                        { url: posImg4, alt: 'POS Billing' },
                        { url: posImg5, alt: 'POS Ordering' },
                    ]}
                />
            </div>
            <div className="container pt-60 pb-80 text-center">
                <div className="mx-auto" style={{ maxWidth: '800px' }}>
                    <p className="mb-3">
                        {' '}
                        Our POS app is the best option for businesses in the hospitality industry,
                        including hotels, restaurants, and bars. With our app, you can streamline
                        your operations, improve efficiency, and gain valuable insights into your
                        business.
                    </p>
                    <p>
                        We are committed to providing our customers with the best possible
                        experience, which is why we offer 24/7 customer support to assist with any
                        questions or issues that may arise. If you're ready to simplify your
                        business operations and improve efficiency, download our app today and start
                        using our integrated POS app.
                    </p>
                </div>
            </div>
            <FooterHomeThree className="appie-footer-about-area" />
            <BackToTop />
        </>
    );
}

export default POS;
